import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ImportCommitResponse, type ImportCommitInput } from "@avestate/shared";
import { apiFetch } from "@/lib/api.js";
import { useAuth } from "@/auth/useAuth.js";

export function useImportCommit() {
  const qc = useQueryClient();
  const { session } = useAuth();
  const token = session?.access_token;

  return useMutation({
    mutationFn: (input: ImportCommitInput) => {
      if (!token) throw new Error("not authenticated");
      return apiFetch("/api/v1/admin/import/commit", token, ImportCommitResponse, { method: "POST", body: input });
    },
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ["listings"] }); },
  });
}
